<template>
    <div v-if="cargando">Cargando</div>
    <div v-else>
        <div v-if="paquetes">
            <p class="md-headline">Paquetes</p>
            <div class="row">
                <boton-panel
                        v-for="item in paquetes"
                        :key="item.id"
                        :datos="item"
                        v-model="formulario.paquete"
                        :valor="formulario.paquete"
                />
            </div>
            <div class="pt-5 d-flex justify-content-between">
                <button type="button" class="btn btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
                <button type="button" :class="estadoBtn ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''"  class="btn btn-primary btn-font-sm" v-on:click="siguiente" :disabled="estadoBtn"> Continuar <i class="flaticon2-next"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import BotonPanel from "../../../componentes/boton-panel";
    import constantes from "../../../constantes";
    export default {
        name: "paquetes",
        data:()=>({
            formulario:{
                paquete:{id:null}
            },
            comparacion:[],
        }),
        props:["cargando","paquetes","numAc","estadoBtn","value"],
        components:{
            BotonPanel
        },
        watch:{
          "formulario.paquete":{
              handler(valor){
                  this.$emit('input',valor);
              },
              deep: true
          },
            "value":function(val){
              this.formulario.paquete=val;
            }
        },
        methods:{
            atras:function(){
                this.$store.commit('setSubActual',1);
            },
            siguiente:function(){
                this.$store.commit('setSubActual',3);
            },
            consulta:function(){
                if(!constantes.funciones.isEmpty(this.$store.getters.getPasos["2"].paquete))
                    this.formulario.paquete=this.$store.getters.getPasos["2"].paquete;
            }
        },
        created() {
            this.consulta();
        }
    }
</script>

<style scoped>

</style>
